import { CSS } from "./styles.js";

export interface MossFoundingAgentElement extends HTMLElement {
  readonly bubble: HTMLDivElement;
  readonly overlay: HTMLDivElement;
}

export const TAG = "moss-founding-agent";

export function ensureRegistered(): void {
  if (typeof customElements === "undefined" || typeof HTMLElement === "undefined") return;
  if (customElements.get(TAG)) return;
  class MossFoundingAgentElementImpl extends HTMLElement {
    readonly bubble: HTMLDivElement;
    readonly overlay: HTMLDivElement;
    constructor() {
      super();
      const root = this.attachShadow({ mode: "open" });
      const style = document.createElement("style");
      style.textContent = CSS;
      root.appendChild(style);
      this.bubble = document.createElement("div");
      this.bubble.className = "moss-bubble";
      root.appendChild(this.bubble);
      this.overlay = document.createElement("div");
      this.overlay.className = "moss-overlay";
      root.appendChild(this.overlay);
    }
  }
  customElements.define(TAG, MossFoundingAgentElementImpl);
}
